import type { ProductData } from "@/mocks/products";

interface Props {
  product: ProductData;
}

export default function IntegrationsSection({ product }: Props) {
  return (
    <section className="py-10 md:py-14 bg-graphite-850/30">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8 md:mb-10 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2">
              Integrations
            </h2>
            <p className="text-base text-silver-400 max-w-2xl mx-auto">
              {product.name.replace("StackMap ", "")} connects seamlessly with the rest of the StackMap platform.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4">
            {product.integrations.map((integration) => (
              <div
                key={integration}
                className="flex items-center gap-2.5 px-5 py-3 rounded-xl bg-graphite-800 border border-graphite-700 hover:border-emerald-accent/40 transition-colors"
              >
                <span className="w-6 h-6 flex items-center justify-center rounded-md bg-emerald-accent/10">
                  <i className="ri-link text-xs text-emerald-accent" />
                </span>
                <span className="text-sm font-medium text-white whitespace-nowrap">
                  {integration}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}